module.exports = __webpack_public_path__ + "img/small-7.48afd863.webp";